<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    湾厦站<br>
站点介绍<br>
湾厦站位于后海滨路和招商东路交接处后海滨路的下方，呈南北走向布置。车站整体装修以绿色为主，绿白相间，表现了湾厦欣欣向荣，和谐舒畅的人文氛围。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:49	00:29	2号线	2分35秒	5分45秒<br>
莲塘	06:01	23:11	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:54	00:29	2号线	4分钟	5分钟<br>
莲塘	06:04	23:11	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:54	01:19	2号线	4分钟	5分钟<br>
莲塘	06:04	00:11	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
后海滨路东侧、招商东路南侧、中心路南侧、绿海湾、湾厦海境界、东角头社区、金色阳光雅居、东帝海景家园、澳城花园、翡翠海岸、鸿威海怡湾、皇庭港湾、阳光海滨花园、中国民生银行、兴业银行、平安银行<br><br>
B出入口:<br>
后海滨路东侧、招商东路北侧、中心路北侧、深圳蒳美迩医疗美容门珍部、卓越维港、吉祥龙花园、宁波银行、卓越中心大道、恒裕嫔城<br><br>
C出入口:<br>
后海滨路西侧、招商东路北侧、招商东路休闲公园、深圳育才三中、深圳市育才第四小学、湾厦村委、港湾创业大厦、后海公馆、后海雅园、港湾创业大厦、广物花园、广博星海华庭、弘都世纪公寓<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 绿海湾<br>
M493<br><br>
B出入口:<br>
公交站名： 湾厦地铁站<br>
M493<br><br>
C出入口:<br>
公交站名： 湾厦地铁站<br>
M493<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>